import { render, staticRenderFns } from "./MassMail.vue?vue&type=template&id=6c7274c1&scoped=true"
import script from "./MassMail.vue?vue&type=script&lang=js"
export * from "./MassMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7274c1",
  null
  
)

export default component.exports